export default __webpack_public_path__ + "static/media/broadsheet.acbbcbe8.svg";